module.exports = __webpack_public_path__ + "static/media/Compass.cbb6b591.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Compass.svg
// module id = 923
// module chunks = 0